import { render, staticRenderFns } from "./AccessRegistrationPersonIn.vue?vue&type=template&id=2cf2bac0&scoped=true"
import script from "./AccessRegistrationPersonIn.vue?vue&type=script&lang=js"
export * from "./AccessRegistrationPersonIn.vue?vue&type=script&lang=js"
import style0 from "./AccessRegistrationPersonIn.vue?vue&type=style&index=0&id=2cf2bac0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf2bac0",
  null
  
)

export default component.exports